<template>
  <div class="exp-tabs-bar">
    <div class="exp-tabs">

      <router-link
        v-if="permission.view_expense == 1"
        :to="$url('/manage-expenses')"
        class="exp-tab"
        :class="isActive(['Manage Expenses', 'Expense Detail', 'Create Expense']) ? 'exp-tab--active' : ''"
      >
        <font-awesome-icon icon="receipt" class="tab-icon" />
        Manage Expenses
      </router-link>

      <router-link
        v-if="permission.view_expense == 1"
        :to="$url('/manage-expense-category')"
        class="exp-tab"
        :class="isActive(['Expense Category']) ? 'exp-tab--active' : ''"
      >
        <font-awesome-icon icon="tags" class="tab-icon" />
        Expense Category
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.exp-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.exp-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.exp-tabs::-webkit-scrollbar { display: none; }

.exp-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.exp-tab:hover { color: #004AAD; text-decoration: none; }

.exp-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

.tab-icon { font-size: 13px; opacity: 0.85; }

@media (max-width: 576px) {
  .exp-tabs-bar { padding: 0 12px; }
  .exp-tab      { padding: 11px 12px; font-size: 13px; }
}
</style>